import { Link } from 'react-router-dom';
import { ArrowRight, Lock } from 'lucide-react';
import { MODULOS, telaPrincipal } from '@/lib/modulos';
import { useAuthStore } from '@/stores/authStore';

/**
 * Os módulos do sistema, a porta de cada um. O que a empresa contratou abre; o
 * que não contratou aparece apagado — é a vitrine do que o sistema ainda faz.
 * Módulo novo em lib/modulos.ts aparece aqui sozinho.
 */
export default function VitrineModulos() {
  const user = useAuthStore((estado) => estado.user);
  const ativos = user?.modulos_ativos ?? [];

  return (
    <section>
      <h2 className="mb-sm text-[11px] font-bold tracking-[0.08em] text-muted uppercase">Módulos</h2>
      <ul className="grid gap-md sm:grid-cols-2 xl:grid-cols-3">
        {Object.entries(MODULOS).map(([slug, modulo]) => {
          const Icone = modulo.icone;
          const contratado = ativos.includes(slug);
          const destino = contratado ? telaPrincipal(user, slug) : null;

          const corpo = (
            <>
              <span
                className={`flex size-10 shrink-0 items-center justify-center rounded-md ${
                  destino ? 'bg-accent/10 text-accent' : 'bg-surface-subtle text-muted'
                }`}
              >
                <Icone size={20} />
              </span>
              <span className="min-w-0 flex-1">
                <span className="flex items-center justify-between gap-sm">
                  <span className={`truncate text-[14px] font-bold ${destino ? 'text-ink' : 'text-muted'}`}>{modulo.nome}</span>
                  {destino ? (
                    <ArrowRight size={16} className="shrink-0 text-muted group-hover:text-accent" />
                  ) : (
                    <span className="inline-flex shrink-0 items-center gap-[3px] text-[11px] text-muted">
                      <Lock size={11} />
                      {contratado ? 'Sem acesso' : 'Não contratado'}
                    </span>
                  )}
                </span>
                <span className="mt-[2px] block text-[12px] text-muted">
                  {destino || !contratado ? modulo.descricao : 'Peça acesso ao administrador da empresa.'}
                </span>
              </span>
            </>
          );

          return (
            <li key={slug}>
              {destino ? (
                <Link
                  to={destino}
                  className="group flex h-full items-start gap-sm rounded-lg border border-border bg-surface p-md transition-colors hover:border-accent"
                >
                  {corpo}
                </Link>
              ) : (
                <div className="flex h-full items-start gap-sm rounded-lg border border-dashed border-border p-md opacity-80">{corpo}</div>
              )}
            </li>
          );
        })}
      </ul>
    </section>
  );
}
